import { createModel } from 'ice';
import type { UserInfo } from './types';
import { fetchUserInfo } from './service';

const emptyUser: UserInfo = {
  userName: '',
  userId: '',
  account: '',
  avatar: '',
  mobile: '',
  email: '',
  platform: '',
  perms: [],
  abilities: [],
  roles: [],
  pagePaths: [],
  apiPaths: [],
  abilitieMap: {},
  roleMap: {},
  groupMap: {},
  groupMapProduct: {},
  groupMapTeams: {},
};

export default createModel({
  state: {
    currentUser: emptyUser,
  } as { currentUser: UserInfo },

  reducers: {
    setCurrentUser(prevState: { currentUser: UserInfo }, payload: UserInfo) {
      prevState.currentUser = payload;
    },
  },

  effects: () => ({
    /** 从 /api/perms/user 拉取用户信息并写入 store */
    async asyncGetUserInfo() {
      const data = await fetchUserInfo();
      this.setCurrentUser(data);
      return data;
    },
  }),
});
